<div class="ac clear-input">
  <input class="ac-input" [ngClass]="valid ? '' : 'ac-input-invalid'" type="text" [placeholder]="placeholder" #searchInput [tabIndex]="focusInputOnLoad ? 0 : null" [disabled]="disabled"
    (input)="input($event)" (click)="click($event)" (keydown)="keydown($event)" (keydown.enter)="addCustomEntry(searchBox.value)" (keyup)="keyup($event)" (blur)="blur($event)" (focus)="focus($event)" #searchBox/>
    @if (allowCustomInput) {
      <i class="return-icon" [ngClass]="{'green' : addingChip}" (click)="addCustomEntry(searchBox.value, true)" [matTooltip]="'Click to add \'' + searchBox.value + '\''" matTooltipShowDelay="500"></i>
    }
    @if (searching) {
      <div class="loading-spinner spinner-border spinner-border-sm"></div>
    }
    @if (!searching) {
      <i [ngClass]="searchInput.value ? 'bhi-times' : 'bhi-search'" class="clear-icon" (click)="clearInput(searchInput, true)" [title]="searchInput.value ? 'Clear' : ''" #clearSearch></i>
    }
    <div #dropDownContainer class="ac-dropdown-container" [ngClass]="embeddedDropDown ? 'embedded' : ''" [style.position]="position"
      [ngStyle]="(items.length === 0 || hide) ? {'display': 'none'} : {'display': 'block'}">
      @for (item of items$ | async ; track item; let i = $index) {
        <div class="ac-item" [ngClass]="i === highlightItemIndex ? 'ac-highlight' : ''"
          (click)="select(item)">
          <div>
            @if (item.icon) {
              <i class="{{item.icon}}"></i>
            }
            {{item.label}}
            @if (item.details) {
              <span class="additional-details">{{item.details}}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
